import { ReactNode, useId } from 'react';

interface Props {
  titulo: string;
  subtitulo: string;
  /** Cartões que a seção exibe no período escolhido (os escondidos pelo filtro de mês não contam). */
  quantidade: number;
  /** Texto de RDV-05 quando a seção não exibe cartão. */
  vazio: string;
  /** Aviso no lugar dos cartões e do vazio, quando a leitura da seção falhou (RDV-34). */
  falha?: ReactNode;
  children?: ReactNode;
}

/** RDV-03 e RDV-05: uma seção da lista do ciclo, com título, quantidade e subtítulo, e o texto de vazio. */
export default function SecaoDaLista({ titulo, subtitulo, quantidade, vazio, falha, children }: Props) {
  const tituloId = useId();

  return (
    <section aria-labelledby={tituloId} className="mt-[22px] flex flex-col gap-3">
      <div className="flex flex-wrap items-baseline gap-2.5">
        <h2 id={tituloId} className="m-0 font-display text-lg font-bold text-brand-blue-dark">
          {titulo}
        </h2>
        <span className="rounded-jj-pill bg-[#EDEFFF] px-2.5 py-[3px] font-display text-[11px] font-bold text-brand-blue">
          {quantidade}
        </span>
        <span className="text-xs text-content-soft">{subtitulo}</span>
      </div>
      {falha ?? (
        <>
          {children}
          {quantidade === 0 && (
            <p className="m-0 rounded-jj-lg border border-dashed border-surface-300 px-[22px] py-[18px] text-[12.5px] leading-[1.6] text-content-soft">
              {vazio}
            </p>
          )}
        </>
      )}
    </section>
  );
}
